import React, { useRef, useEffect } from 'react';
import { compose } from 'redux';
import Form from './Base';

import { withCancelForm } from '../../hocs/withActions';
import { withScreenData, withShouldSubmit } from '../../hocs/withData';

const MainForm = ({
  CancelForm = () => { },
  children,
  onSubmit = () => { },
  shouldSubmit = false,
}) => {
  const formRef = useRef(null);

  useEffect(() => {
    if (shouldSubmit) {
      formRef.current.submit();
    }
  }, [shouldSubmit]);

  return (
    <Form ref={formRef} onSubmit={onSubmit} onError={CancelForm}>
      {children}
    </Form>
  );
}

export default compose(
  withCancelForm,
  withScreenData,
  withShouldSubmit,
)(MainForm);
